import type { PaymentOption } from '../api/types';
import { CHAINS } from '../chains';

/**
 * Mobile deep links. On a phone without an injected provider we hand the
 * payment request to a wallet app via its universal link. Every link encodes
 * the merchant address and exact amount, so the user only confirms.
 */
export interface DeepLink {
  name: string;
  href: string;
}

export function deepLinksFor(option: PaymentOption): DeepLink[] {
  const kind = CHAINS[option.chain].kind;
  const links: DeepLink[] = [];
  const here = encodeURIComponent(location.href);

  if (kind === 'evm' && option.chain_id) {
    // MetaMask universal links: native send and ERC-20 transfer forms.
    const mm = option.token_contract
      ? `https://metamask.app.link/send/${option.token_contract}@${option.chain_id}/transfer?address=${option.address}&uint256=${option.amount_minor}`
      : `https://metamask.app.link/send/${option.address}@${option.chain_id}?value=${option.amount_minor}`;
    links.push({ name: 'MetaMask', href: mm });
    // Coinbase Wallet / Trust Wallet open this checkout in their in-app browser
    // where window.ethereum is injected and the normal flow continues.
    links.push({ name: 'Coinbase Wallet', href: `https://go.cb-w.com/dapp?cb_url=${here}` });
    links.push({ name: 'Trust Wallet', href: `https://link.trustwallet.com/open_url?coin_id=60&url=${here}` });
  }
  if (kind === 'solana') {
    links.push({ name: 'Phantom', href: `https://phantom.app/ul/browse/${here}?ref=${encodeURIComponent(location.origin)}` });
  }
  if (kind === 'tron') {
    links.push({ name: 'TronLink', href: `tronlinkoutside://pull.activity?param=${encodeURIComponent(JSON.stringify({ url: location.href, action: 'open', protocol: 'tronlink', version: '1.0' }))}` });
  }
  // The raw payment URI (bitcoin:, ethereum: EIP-681, solana:) is
  // handled by whichever wallet registered the scheme.
  if (option.uri) links.push({ name: 'Any wallet (payment URI)', href: option.uri });
  return links;
}
